import { render, staticRenderFns } from "./TradingChartView.vue?vue&type=template&id=793d9000&scoped=true&"
import script from "./TradingChartView.vue?vue&type=script&lang=js&"
export * from "./TradingChartView.vue?vue&type=script&lang=js&"
import style0 from "./TradingChartView.vue?vue&type=style&index=0&id=793d9000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d9000",
  null
  
)

export default component.exports